const getPortalByTenantType = (tenantType) => {
  switch (tenantType) {
    case "admin":
      return { userType: "admin", dashboardRoute: "/dashboard-admin" };

    case "fleet_manager":
      return { userType: "manager", dashboardRoute: "/dashboard-manager" };

    case "fuel_vendor":
      return { userType: "vendor", dashboardRoute: "/dashboard-vendor" };

    default:
      return null;
  }
};

export default getPortalByTenantType;
